module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapterHead",
    attrs: {
      "id": "Contents"
    }
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1-TS"
  }, [_c('a', {
    attrs: {
      "href": "#/05_00_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1-BS"
  }, [_c('a', {
    attrs: {
      "href": "#/06_00_Photograph_Sources"
    }
  }, [_vm._v("Photograph Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_00_Chapter1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/07_00_Chapter1"
    }
  }, [_vm._v("Mussolini’s Panzers")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/08_00_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/08_00_Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Western Desert Force")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/09_00_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/09_00_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Fox killed in the open’ – Beda Fomm")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_00_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/10_00_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("East African Distraction")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_00_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/11_00_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Desert Fox Arrives")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_00_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/12_00_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Churchill’s ‘Battleaxe’")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_00_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/13_00_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crusader – Panzergruppe Afrika Driven Back")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_00_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/14_00_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grant and Sherman – The Americans Are Coming!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_00_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/15_00_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Alamein – Rommel Defeated")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_00_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/16_00_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kasserine – The Panzers’ Last Hurrah")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_00_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/17_00_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mareth and Longstop – The Road to Tunis")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd27350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_00_Contents.vue
// module id = 66
// module chunks = 0